import { AloProxy } from '@/models/alo/AloProxy'
import { AlrContainer } from '@/models/response/AlrContainer'
import apiHelpers from '@/utils/api'
import { encodeUrl64 } from '@/utils/base64'
import { AxiosPromise } from 'axios'
import md5 from 'md5'

export default {
  /**
   * @returns {Promise}
   */
  proxify(url: string): AxiosPromise<AlrContainer<AloProxy>> {
    const urlObj = new URL(url)
    const sh = urlObj.protocol == 'http:' ? 'unsec' : 'sec'
    const sel = encodeUrl64(Math.random().toString()).substring(0, 15)
    const paramName = encodeUrl64(Math.random().toString())
      .substring(0, Math.max(3, Math.round(Math.random() * 7)))
      .toLowerCase()
    const secureValue = encodeUrl64(md5(`${url}${sel}`))

    urlObj.searchParams

    const secuUrl = encodeUrl64(
      `${url.replace(`${urlObj.protocol}//`, '')}${urlObj.search.length == 0 ? '?' : '&'}${paramName}=${secureValue}`,
    )

    return apiHelpers.apiCall({
      url: '/api/databind',
      method: 'POST',
      data: {
        sh,
        u: secuUrl,
        s: sel,
      },
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloProxy>(JSON.parse(data), AloProxy.createAloAloProxy)
        },
      ],
    })
  },
  authGeoserver() {
    return apiHelpers.apiCall({
      url: '/api/georequester/auth',
      method: 'GET',
    })
  },
}
